import React, { Component } from 'react';
import SignUpFormComponent from 'components/SignUpForm/SignUpPageForm';
import SocialFooter from 'components/SocialFooter/SocialFooter';
import EnkiLogo from 'components/Image/EnkiLogo';
import CookieService from 'services/CookieService';
import { RoutePermissionService } from 'services/RoutePermissionService';
import LoginIllustration from 'components/Image/LoginIllustration'
import { UserDataProvider } from 'providers/user/UserDataProvider';
import { Link } from 'react-router-dom'
import './signup-page.scss'

export class SingupPage extends Component {
  constructor(props) {
    super(props)
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.checkToken = this.checkToken.bind(this);
  }

  componentDidMount() {
    this.checkCookie();
  }

  checkCookie() {
    const token = new CookieService().getCookie('token');
    if (token != undefined && token.length > 0) {
      this.checkToken(token);
    }
  }

  checkToken(token) {
    this.setState({ loaderIsActive: true, showMessageBox: false })
    const host = process.env.REACT_APP_SERVER;
    const body = {
      'addToken': true
    };
    new UserDataProvider().getCurrentUsersData().then((result) => {
      if (result.hasOwnProperty('email') && result.userType !== 'demo') {
        this.onFormSubmit(result);
      }
    })
      .catch((err) => {
        console.log(err)
      });
  }

  onFormSubmit(result) {
    const { propsData } = this.props.location;
    if (!propsData) {
      this.props.history.push('/');
      return;
    }

    const { location } = propsData;
    const { userType } = result;
    const cookieService = new CookieService();
    cookieService.setCookie({ name: 'user_type', value: userType }, 10);
    const routeResult = new RoutePermissionService().checkRoutePermission(location);
    if (!routeResult.result) {
      location.pathname = '/';
    }

    const Path = this.getPathForUser(location, userType);
    this.props.history.push(Path);
  }

  getPathForUser(location, userType) {
    const { pathname, search = '' } = location;
    return {
      'freemium': { pathname: pathname == '/' && search.isNullOrEmpty() ? 'research' : pathname, search: search },
      'premium': { pathname: pathname == '/' && search.isNullOrEmpty() ? 'dashboard/reports' : pathname, search: search },
      'demo': { pathname: pathname == '/' && search.isNullOrEmpty() ? 'demo' : pathname, search: search },
    }[userType];
  }

  render() {
    return (
      <div className="margin-t-0">
        <div className="signup-page">
          <div className="signup-page__content">
            <div className="signup-page__content__logo">
              <Link to={`/`}>
                <EnkiLogo />
              </Link>
            </div>
            <div className="signup-page__content__form">
              <SignUpFormComponent onSubmit={this.onFormSubmit} plan={this.props.plan || 'junior'}></SignUpFormComponent>
            </div>
            <SocialFooter />
          </div>
          <div className="signup-page__slider">
            <div className="signup-page__slider__head">
              <h2>Insights as Fast as You Think</h2>
              <span>Answers in Minutes—Not Days</span>
            </div>
            <div className="signup-page__slider__carousel">
              <LoginIllustration variant="showcase" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SingupPage;
